/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React, { Fragment } from 'react'

import { EuiTextColor } from '@elastic/eui'

import type { AdminConsoleCCMCluster } from '@modules/ccm-admin-lib/types'
import { isDisconnectedCluster } from '@modules/ccm-admin-lib/util'

import type { FC, ReactNode } from 'react'

const ColumnTextColorWrapper: FC<{
  ccmCluster: AdminConsoleCCMCluster
  children: ReactNode
}> = ({ ccmCluster, children }) => {
  if (isDisconnectedCluster(ccmCluster)) {
    return <EuiTextColor color='subdued'>{children}</EuiTextColor>
  }

  return <Fragment>{children}</Fragment> // Wrapping in Fragment due to ReactNode vs ReactElement type mismatch
}

export default ColumnTextColorWrapper
